export default __webpack_public_path__ + "static/media/discover.fa31f6c1.svg";